import { render, staticRenderFns } from "./employee-list.vue?vue&type=template&id=854bdb60&scoped=true&"
import script from "./employee-list.vue?vue&type=script&lang=js&"
export * from "./employee-list.vue?vue&type=script&lang=js&"
import style0 from "./employee-list.vue?vue&type=style&index=0&id=854bdb60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854bdb60",
  null
  
)

export default component.exports